import { OperationVariables, gql } from '@apollo/client';
import { useLazyQuery, useQuery } from '@apollo/client/react';
import { GetLanguagesContinents } from './__generated__/GetLanguagesContinents';
export const GET_LANGUAGES_CONTINENTS = gql`
  query GetLanguagesContinents {
    languages {
      id
      name(languageId: "529") {
        value
      }
      countryLanguages {
        country {
          continent {
            id
          }
        }
      }
    }
  }
`;
export function useLanguagesContinentsQuery() {
  return useQuery(GET_LANGUAGES_CONTINENTS);
}
export function useLanguagesContinentsLazyQuery() {
  return useLazyQuery(GET_LANGUAGES_CONTINENTS);
}